export default __webpack_public_path__ + "static/media/courses-at-parks-and-recs.7a4dcb6d.png";